import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'AuditConfigurationType', method: 'GET', token: token })
}
